import { render, staticRenderFns } from "./priceList.vue?vue&type=template&id=0e800601&"
import script from "./priceList.vue?vue&type=script&lang=js&"
export * from "./priceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e800601')) {
      api.createRecord('0e800601', component.options)
    } else {
      api.reload('0e800601', component.options)
    }
    module.hot.accept("./priceList.vue?vue&type=template&id=0e800601&", function () {
      api.rerender('0e800601', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/performancecenter/theaterManage/priceList.vue"
export default component.exports